import type { IconSvgObject } from './types';

const MailSend02Icon: IconSvgObject = [
  ["path", { d: "M11 20H4C2.89543 20 2 19.1046 2 18V6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.5 15L22 17.5L19.5 15ZM19.5 20L22 17.5L19.5 20Z", fill: "currentColor", key: "1" }],
  ["path", { d: "M19.5 15L22 17.5L19.5 20M14.5 17.5L21.3912 17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M6 8L10.9923 10.9122C11.615 11.2754 12.385 11.2754 13.0077 10.9122L18 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default MailSend02Icon;
